import { BankSEOConfig } from '../types';
import defaultConfig from './config.default';

const bankName = 'Ringkjøbing Landbobank';

const config: BankSEOConfig = {
  ...defaultConfig,
  fullBankName: bankName,
  branchOverviewPage: {
    title: 'Find medarbejdere og afdelinger',
    description:
      'Se alle Ringkjøbing Landbobanks afdelinger. Søg efter en medarbejder og find kontaktoplysninger og åbningstider.'
  }
};

export default config;
